<div [id]="'checkout-step-' + name"
     [class.ng-hide]="hide">
    <ng-content class="w-12 w-10-m"></ng-content>
</div>